import { useEffect } from 'react';
import { useRegisterInlineFieldEditor, useWasUndoRedoEventWithData } from '../lib/InlineFieldEditingHooks';
const ReadOnlyFieldEditor = ({
  node,
  currentValue,
  moduleName
}) => {
  useRegisterInlineFieldEditor(moduleName);
  const wasUndoRedo = useWasUndoRedoEventWithData(currentValue);

  // Make sure updates from the sidebar are also applied to the DOM
  useEffect(() => {
    if (currentValue !== undefined && node.innerText !== currentValue && (document.activeElement !== node || wasUndoRedo)) {
      node.innerText = currentValue;
    }
  }, [currentValue, node, wasUndoRedo]);
  return null;
};
export default ReadOnlyFieldEditor;